import { Col, Container, Row, Text } from '@qonsoll/react-design'

import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'

export default function RewardRewardStatus(props) {
  const { reward } = props

  /* Getting translation instance */
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {reward?.status ? (
            <Text>{reward?.status}</Text>
          ) : (
            <Text type="secondary" variant="overline">
              {t('No reward statuses have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

RewardRewardStatus.propTypes = {
  reward: PropTypes.object.isRequired
}
